// Переводы ответов Финтабло на язык пользователя.
//
// Провайдерская ошибка не должна превращаться в пустой список: 2026-08-12 на
// production Финтабло отвечал 400 «Deals module is not active», редактор молча
// показывал пустой выпадающий список статусов, и причина выяснялась только по
// логам сервера.
const FINTABLO_ERRORS = {
  'Deals module is not active. Please, pay for it':
    'Модуль сделок не активен — необходимо оплатить подписку Финтабло'
}

export function translateFintabloError (message) {
  if (!message) return 'Не удалось получить данные Финтабло'
  return FINTABLO_ERRORS[message] || message
}
